<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { fullstory } from "env";
import { register } from "@unimed/unijs/store";
import { insertScript } from "./utils/fullstory.js";
import requires from "./utils/require.js";

export default {
  created() {
    if (this.$store) {
      register(this.$store);
    }
    if (fullstory) {
      insertScript(fullstory);
    }

    requires();
  }
};
</script>

<style lang="scss" scoped>
@import "../node_modules/@unimed/unijs/static/bulma.css";

#app {
  height: 100vh;
}
</style>

<style>
html {
  height: 100%;
  width: 100%;
}
</style>
